import { server } from '../core/server/axios';

export class PkbController {
	//1 метод
	async sendRequest(iin: string): Promise<any> {
		return await server.get(`/Gbdfl/send-request/${iin}`, {
			baseURL: "https://pkb.quiq.kz"
		});
	}

	async getClientInfo({ iin, requestId }: { iin: string, requestId: string }): Promise<any> {
		return await server.get(`Gbdfl/client-info/${iin}/${requestId}`, {
			baseURL: "https://pkb.quiq.kz"
		});
	}
	//1 метод



	//2 метод
	async sendCode({ iin, phone }: { iin: string, phone: string }): Promise<any> {
		return await server.post(`Fc/send-code?iin=${iin}&phone=${phone}`, {}, {
			baseURL: "https://pkb.quiq.kz"
		});
	}

	async getClientDoc({ iin, firstName, lastName, code }: { iin: string, firstName: string, lastName: string, code: string }): Promise<any> {
		return await server.post(`Fc/get-json-doc?iin=${iin}&firstname=${firstName}&lastname=${lastName}&code=${code}`, {}, {
			baseURL: "https://pkb.quiq.kz"
		});
	}
	//2 метод
}